import { CORE_SERVICES } from "../constants/index";
// import { message } from "antd";
import Repository from "../../apiCall/Repository";

export function CallCoreServicesAction(endPoint, jdata, additionSeperator) {
  return async function (dispatch, getState) {
    // const token = getState().auth.token;
    const token = "";

    if (token === "") {
      // message.error(
      //   "توکن خالی است و متد در life Cycle اشتباهی فراخوانی شده است"
      // );
    }

    dispatch({
      type: CORE_SERVICES,
      entity: endPoint,
      action: "action",
      data: [],
      isFetching: true,
      hasError: false,
      message: "",
      additionSeperator,
    });

    const Response = await Repository.CoreServices.CoreServiceApi(
      token,
      endPoint,
      jdata
    );

    let ReturnRedux = {};
    if (Response.id > 0) {
      ReturnRedux = {
        type: CORE_SERVICES,
        entity: endPoint,
        action: "action",
        data: Response.traceMessage,
        isFetching: false,
        hasError: false,
        message: Response.message,
        additionSeperator,
      };
      dispatch(ReturnRedux);
    } else {
      ReturnRedux = {
        type: CORE_SERVICES,
        entity: endPoint,
        action: "action",
        data: null,
        isFetching: false,
        hasError: true,
        message: Response.message,
        additionSeperator,
      };
      dispatch(ReturnRedux);
    }
    return Promise.resolve(ReturnRedux);
  };
}

export function CallCoreServicesActionWithToken(
  endPoint,
  jdata,
  additionSeperator
) {
  return async function (dispatch, getState) {
    const token = getState().coreservices?.coreData?.token?.jwt?.data;

    // console.log("token in call coreservicess=", token);

    if (token === "") {
      // message.error(
      //   "توکن خالی است و متد در life Cycle اشتباهی فراخوانی شده است"
      // );
    }

    dispatch({
      type: CORE_SERVICES,
      entity: endPoint,
      action: "action",
      data: [],
      isFetching: true,
      hasError: false,
      message: "",
      additionSeperator,
    });

    const Response = await Repository.CoreServices.CoreServiceApi(
      token,
      endPoint,
      jdata
    );
    let ReturnRedux = {};
    if (Response.id > 0) {
      ReturnRedux = {
        type: CORE_SERVICES,
        entity: endPoint,
        action: "action",
        data: Response.traceMessage,
        isFetching: false,
        hasError: false,
        message: Response.message,
        additionSeperator,
      };
      dispatch(ReturnRedux);
    } else {
      ReturnRedux = {
        type: CORE_SERVICES,
        entity: endPoint,
        action: "action",
        data: null,
        isFetching: false,
        hasError: true,
        message: Response.message,
        additionSeperator,
      };
      dispatch(ReturnRedux);
    }
    return Promise.resolve(ReturnRedux);
  };
}
export function OfflineCoreServices(
  endPoint,
  action,
  data,
  isFetching,
  hasError,
  message
) {
  return async function (dispatch) {
    //  debugger;
    dispatch({
      type: CORE_SERVICES,
      entity: endPoint,
      action,
      data,
      isFetching,
      hasError,
      message,
    });
  };
}
